export default {
  'pages.request.loginExpired': '登录状态已失效，请重新登录',
  'pages.request.accessDenied': '您没有执行此操作的权限',
  'pages.request.responseStatus': '请求失败（HTTP {status}）',
  'pages.request.noResponse': '服务器未响应，请稍后重试',
  'pages.request.error': '请求失败，请稍后重试',
  'pages.login.success': '登录成功！',
  'pages.login.permissionsLoadFailed':
    '权限加载失败，已进入个人地址簿；请刷新页面重试。',
  'pages.login.permissionsRetry': '重试',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.username.placeholder': '用户名',
  'pages.login.username.required': '请输入用户名!',
  'pages.login.password.placeholder': '密码',
  'pages.login.password.required': '请输入密码！',
  'pages.login.rememberMe': '记住我',
  'pages.login.forgotPassword': '忘记密码？',
  'pages.login.forgotPasswordInfo': '请联系管理员重置密码',
  'pages.login.submit': '登录',
  'pages.login.back': '返回',
  'pages.login.emailCheck.title': '邮箱验证',
  'pages.login.emailCheck.description': '6位验证码已发送至 {email}',
  'pages.login.emailCheck.sent': '验证码已发送至您的邮箱',
  'pages.login.tfaCheck.title': '双因素认证',
  'pages.login.tfaCheck.description': '请输入认证器应用中的6位验证码',
  'pages.login.verifyCode.submit': '验证',
  'pages.login.verifyCode.invalid': '验证码无效',
  'pages.login.oidc.divider': '或使用以下方式登录',
  'pages.login.oidc.continueWith': '使用 {provider} 继续',
  'pages.login.oidc.authFailed': 'OIDC登录失败',
  'pages.login.passkey.login': '使用 Passkey 登录',
  'pages.login.passkey.verify': '使用 Passkey 验证',
  'pages.login.passkey.cancelled': 'Passkey 验证已取消',
  'pages.login.passkey.failed': 'Passkey 验证失败',
  'pages.login.passkeyCheck.title': 'Passkey 验证',
  'pages.login.passkeyCheck.description': '请使用您的 Passkey 完成登录',
  'pages.devices.list': '设备列表',
  'pages.devices.os': '操作系统',
  'pages.devices.status': '状态',
  'pages.devices.user': '用户',
  'pages.devices.deviceGroup': '设备组',
  'pages.devices.note': '备注',
  'pages.devices.online': '在线',
  'pages.devices.offline': '离线',
  'pages.devices.days': '天',
  'pages.devices.hours': '小时',
  'pages.devices.minutes': '分钟',
  'pages.devices.justNow': '刚刚',
  'pages.devices.enable': '启用',
  'pages.devices.disable': '禁用',
  'pages.devices.enableSuccess': '设备已启用',
  'pages.devices.enableFailed': '启用设备失败',
  'pages.devices.disableSuccess': '设备已禁用',
  'pages.devices.disableFailed': '禁用设备失败',
  'pages.devices.deleteSuccess': '设备已删除',
  'pages.devices.deleteFailed': '删除设备失败',
  'pages.devices.deleteConfirm': '确定要删除此设备吗？',
  'pages.devices.deviceInfo': '用户名@设备名',
  'pages.devices.strategyInfo': '策略信息',
  'pages.devices.device': '设备',
  'pages.devices.strategy': '策略',
  'pages.devices.info': '信息',
  'pages.devices.statusNormal': '正常',
  'pages.devices.statusDisabled': '已禁用',
  'pages.devices.onlineStatus': '在线状态',
  'pages.devices.deviceGroupSearchTip': '按设备组名称筛选',
  'pages.devices.remove': '移除',
  'pages.devices.removeFromGroupSuccess': '设备已从组中移除',
  'pages.devices.removeFromGroupFailed': '从组中移除设备失败',
  'pages.devices.removeFromGroupConfirm': '确定要从组中移除此设备吗？',
  'pages.devices.batchRemove': '批量移除',
  'pages.devices.batchRemoveFromGroupSuccess': '成功从组中移除 {count} 个设备',
  'pages.devices.batchRemoveFromGroupFailed': '从组中移除设备失败',
  'pages.devices.batchRemoveFromGroupConfirm': '确定要从组中移除选中的设备吗？',
  'pages.devices.batchEnable': '批量启用',
  'pages.devices.batchDisable': '批量禁用',
  'pages.devices.batchEnableConfirm': '确定要启用选中的设备吗？',
  'pages.devices.batchDisableConfirm': '确定要禁用选中的设备吗？',
  'pages.devices.batchEnableSuccess': '成功启用 {count} 个设备',
  'pages.devices.batchEnableFailed': '启用设备失败',
  'pages.devices.batchEnablePartialFailed':
    '成功启用 {success} 个设备，{failed} 个失败',
  'pages.devices.batchDisableSuccess': '成功禁用 {count} 个设备',
  'pages.devices.batchDisableFailed': '禁用设备失败',
  'pages.devices.batchDisablePartialFailed':
    '成功禁用 {success} 个设备，{failed} 个失败',
  'pages.devices.edit': '编辑设备',
  'pages.devices.updateSuccess': '设备已更新',
  'pages.devices.updateFailed': '更新设备失败',
  'pages.devices.selectUser': '选择用户',
  'pages.devices.selectDeviceGroup': '选择设备组',
  'pages.devices.selectStrategy': '选择策略',
  'pages.devices.connect': '连接',
  'pages.devices.connectRemoteDesktop': '远程桌面',
  'pages.devices.connectFileTransfer': '文件传输',
  'pages.devices.connectViewCamera': '查看摄像头',
  'pages.devices.connectPortForward': '端口转发',
  'pages.devices.connectRdp': 'RDP',
  'pages.devices.connectTerminal': '终端',
  'pages.devices.connectTerminalAdmin': '管理员终端',
  'pages.devices.searchIdPlaceholder': '搜索设备ID',
  'pages.devices.searchUserPlaceholder': '搜索用户名',
  'pages.devices.searchOsPlaceholder': '搜索操作系统',
  'pages.devices.searchDeviceGroupPlaceholder': '搜索设备组名称',
  'pages.addressBook.name': '名称',
  'pages.addressBook.note': '备注',
  'pages.addressBook.shared': '共享地址簿',
  'pages.addressBook.create': '创建地址簿',
  'pages.addressBook.edit': '编辑地址簿',
  'pages.addressBook.personal': '个人地址簿',
  'pages.addressBook.currentAddressBook': '地址簿',
  'pages.addressBook.myAddressBook': '我的地址簿',
  'pages.addressBook.loadFailed': '加载地址簿失败',
  'pages.addressBook.addPeer': '按 ID 添加',
  'pages.addressBook.addTag': '添加标签',
  'pages.addressBook.tagName': '标签名称',
  'pages.addressBook.tagAdded': '标签已添加',
  'pages.addressBook.tagAddFailed': '添加标签失败',
  'pages.addressBook.tagDeleted': '标签已删除',
  'pages.addressBook.tagDeleteFailed': '删除标签失败',
  'pages.addressBook.deleteTagConfirm': '确定要删除此标签吗？',
  'pages.addressBook.tagModeUnion': '任一',
  'pages.addressBook.tagModeIntersection': '全部',
  'pages.addressBook.importDevices': '从设备导入',
  'pages.addressBook.importSuccess': '成功导入 {count} 个设备',
  'pages.addressBook.importPartialFailed': '{count} 个设备导入失败',
  'pages.addressBook.createSuccess': '地址簿已创建',
  'pages.addressBook.createFailed': '创建地址簿失败',
  'pages.addressBook.updateSuccess': '地址簿已更新',
  'pages.addressBook.updateFailed': '更新地址簿失败',
  'pages.addressBook.deleteSuccess': '地址簿已删除',
  'pages.addressBook.deleteFailed': '删除地址簿失败',
  'pages.addressBook.deleteConfirm': '确定要删除此地址簿吗？',
  'pages.addressBook.batchDeleteConfirm': '确定要删除选中的地址簿吗？',
  'pages.addressBook.device': '设备',
  'pages.addressBook.alias': '别名',
  'pages.addressBook.tags': '标签',
  'pages.addressBook.peerAdded': '设备已添加',
  'pages.addressBook.peerAddFailed': '添加设备失败',
  'pages.addressBook.peerDeleted': '设备已删除',
  'pages.addressBook.peerDeleteFailed': '删除设备失败',
  'pages.addressBook.deletePeerConfirm': '确定要删除此设备吗？',
  'pages.addressBook.import': '从设备导入',
  'pages.deviceGroups.list': '设备组列表',
  'pages.deviceGroups.name': '名称',
  'pages.deviceGroups.note': '备注',
  'pages.deviceGroups.create': '创建设备组',
  'pages.deviceGroups.edit': '编辑设备组',
  'pages.deviceGroups.createSuccess': '设备组已创建',
  'pages.deviceGroups.createFailed': '创建设备组失败',
  'pages.deviceGroups.updateSuccess': '设备组已更新',
  'pages.deviceGroups.updateFailed': '更新设备组失败',
  'pages.deviceGroups.deleteSuccess': '设备组已删除',
  'pages.deviceGroups.deleteFailed': '删除设备组失败',
  'pages.deviceGroups.deleteConfirm': '确定要删除此设备组吗？',
  'pages.deviceGroups.import': '导入',
  'pages.deviceGroups.importDevices': '导入设备',
  'pages.deviceGroups.importSuccess': '成功导入 {count} 个设备',
  'pages.deviceGroups.importFailed': '导入设备失败',
  'pages.deviceGroups.searchNamePlaceholder': '搜索名称',
  'pages.users.list': '用户列表',
  'pages.users.name': '用户名',
  'pages.users.displayName': '显示名称',
  'pages.users.email': '邮箱',
  'pages.users.note': '备注',
  'pages.users.status': '状态',
  'pages.users.create': '创建用户',
  'pages.users.createSuccess': '用户已创建',
  'pages.users.createFailed': '创建用户失败',
  'pages.users.deleteSuccess': '用户已删除',
  'pages.users.deleteFailed': '删除用户失败',
  'pages.users.deleteConfirm': '确定要删除此用户吗？',
  'pages.audits.conn': '连接审计',
  'pages.audits.file': '文件传输日志',
  'pages.audits.alarm': '告警审计',
  'pages.audits.console': '控制台审计',
  'pages.audits.requestedAt': '请求时间',
  'pages.audits.establishedAt': '建立时间',
  'pages.audits.closedAt': '关闭时间',
  'pages.audits.action': '操作',
  'pages.audits.time': '时间',
  'pages.audits.alarmType': '告警类型',
  'pages.audits.user': '用户',
  'pages.audits.detail': '详情',
  'pages.audits.operator': '操作人',
  'pages.audits.targetType': '目标类型',
  'pages.audits.targetId': '目标 ID',
  'pages.audits.result': '结果',
  'pages.audits.reason': '原因',
  'pages.audits.unknownUser': '未知用户',
  'pages.audits.result.allowed': '允许',
  'pages.audits.result.denied': '拒绝',
  'pages.audits.target': '目标',
  'pages.audits.beforeState': '变更前状态',
  'pages.audits.afterState': '变更后状态',
  'pages.audits.type': '类型',
  'pages.audits.connType.remoteDesktop': '远程桌面',
  'pages.audits.connType.fileTransfer': '文件传输',
  'pages.audits.connType.portTransfer': '端口转发',
  'pages.audits.connType.viewCamera': '查看摄像头',
  'pages.audits.connType.terminal': '终端',
  'pages.audits.connType.notLoggedIn': '未登录',
  'pages.audits.duration': '持续时间',
  'pages.audits.note': '备注',
  'pages.audits.disconnect': '断开连接',
  'pages.audits.connectionId': '连接 ID',
  'pages.audits.currentConnections': '当前连接',
  'pages.audits.disconnectSuccess': '断开请求已提交',
  'pages.audits.disconnectFailed': '断开连接失败！',
  'pages.audits.disconnectConfirmTitle': '确认操作',
  'pages.audits.disconnectConfirmTip': '确定要断开此设备的连接吗？',
  'pages.audits.updateSuccess': '更新成功',
  'pages.audits.updateFailed': '更新失败，请重试！',
  'pages.audits.exportCSV': '导出CSV',
  'pages.audits.noDataToExport': '没有数据可导出',
  'pages.audits.exportSuccess': '导出成功',
  'pages.audits.exportFailed': '导出失败',
  'pages.audits.exportConfirmTitle': '导出CSV',
  'pages.audits.exportConfirmContent': '一次最多导出1000条记录，是否继续？',
  'pages.audits.remote': '远程',
  'pages.audits.local': '本地',
  'pages.audits.direction': '方向',
  'pages.audits.files': '个文件',
  'pages.audits.remoteTip': '远程控制的计算机或终端',
  'pages.audits.remoteSearchTip': '按远程设备ID搜索（模糊匹配）',
  'pages.audits.remotePlaceholder': '请输入远程设备ID',
  'pages.audits.pathTip': '远程设备路径',
  'pages.audits.exportCsvTip': '一次最多导出1000条记录',
  'pages.audits.limitedTip': '按大小显示前10个文件',
  'pages.audits.startTime': '开始时间',
  'pages.audits.endTime': '结束时间',
  'pages.audits.alarmType.ipWhitelist': 'IP不在白名单',
  'pages.audits.alarmType.exceedThirtyAttempts': '同一IP超过30次失败尝试',
  'pages.audits.alarmType.sixAttemptsWithinOneMinute': '1分钟内超过6次尝试',
  'pages.audits.alarmType.exceedIpv6PrefixAttempts': 'IPv6前缀尝试次数超限',
  'pages.audits.alarmType.terminalOsLoginBackoff': '终端OS登录被退避阻止',
  'pages.audits.alarmType.terminalOsLoginConcurrency': '终端OS登录并发数超限',
  'pages.audits.alarmType.sessionScopeViolation': '会话范围权限违规',
  'pages.audits.alarmType.idWhitelist': 'ID不在白名单',
  'pages.audits.primaryAuth': '主认证方式',
  'pages.audits.primaryAuth.none': '无',
  'pages.audits.primaryAuth.click': '点击',
  'pages.audits.primaryAuth.temporaryPassword': '临时密码',
  'pages.audits.primaryAuth.permanentPassword': '固定密码',
  'pages.audits.primaryAuth.switchSides': '反向请求',
  'pages.audits.twoFactor': '二因素认证',
  'pages.audits.twoFactor.none': '无',
  'pages.audits.twoFactor.totp': 'TOTP',
  'pages.audits.twoFactor.trustedDevice': '可信设备',
  'pages.audits.searchOperatorPlaceholder': '搜索操作者',
  'pages.audits.searchActionPlaceholder': '搜索操作',
  'pages.audits.searchTargetTypePlaceholder': '搜索目标类型',
  'pages.common.action': '操作',
  'pages.common.delete': '删除',
  'pages.common.edit': '编辑',
  'pages.common.batchDelete': '批量删除',
  'pages.404.subTitle': '抱歉，您访问的页面不存在',
  'pages.404.buttonText': '返回首页',
  'pages.customClients.createdAt': '创建时间',
  'pages.userGroups.list': '用户组列表',
  'pages.userGroups.name': '组名称',
  'pages.userGroups.note': '备注',
  'pages.userGroups.userCount': '用户数',
  'pages.userGroups.create': '创建用户组',
  'pages.userGroups.edit': '编辑用户组',
  'pages.userGroups.deleteConfirm': '确定要删除此用户组吗？',
  'pages.userGroups.createSuccess': '用户组已创建',
  'pages.userGroups.createFailed': '创建用户组失败',
  'pages.userGroups.updateSuccess': '用户组已更新',
  'pages.userGroups.updateFailed': '更新用户组失败',
  'pages.userGroups.deleteSuccess': '用户组已删除',
  'pages.userGroups.deleteFailed': '删除用户组失败',
  'pages.userGroups.loadFailed': '加载用户组失败',
  'pages.userGroups.default': '默认',
  'pages.userGroups.destination': '目标用户组',
  'pages.userGroups.selectDestination': '选择目标用户组',
  'pages.userGroups.move': '移动',
  'pages.userGroups.batchMove': '批量移动',
  'pages.userGroups.moveToGroup': '移动到用户组',
  'pages.userGroups.import': '导入',
  'pages.userGroups.importUsers': '导入用户',
  'pages.userGroups.importSuccess': '成功导入 {count} 个用户',
  'pages.userGroups.importFailed': '导入用户失败',
  'pages.userGroups.membersUpdated': '已更新 {count} 个用户',
  'pages.userGroups.membersUpdateFailed': '更新用户组成员失败',
  'pages.userGroups.members': '成员',
  'pages.userGroups.moveSelected': '移动所选用户',
  'pages.userGroups.addSelected': '添加所选用户',
  'pages.userGroups.membersTitle': '{name} 的成员',
  'pages.userGroups.currentMembers': '当前成员',
  'pages.userGroups.addUsers': '添加用户',
  'pages.users.userGroup': '用户组',
  'pages.users.selectUserGroup': '请选择用户组',
  'pages.addressBook.userGroup': '用户组',
  'pages.addressBook.permission': '权限',
  'pages.addressBook.permissionRead': '只读',
  'pages.addressBook.permissionReadWrite': '读写',
  'pages.addressBook.permissionFull': '完全控制',
  'pages.addressBook.shareAccess': '共享',
  'pages.addressBook.accessTitle': '{name} - 共享管理',
  'pages.addressBook.accessReadOnlyTitle': '{name} - 共享设置',
  'pages.addressBook.viewShareSettings': '共享设置',
  'pages.addressBook.shareType': '共享类型',
  'pages.addressBook.shareTarget': '共享对象',
  'pages.addressBook.shareTypeEveryone': '所有人',
  'pages.addressBook.shareTypeUser': '用户',
  'pages.addressBook.shareTypeGroup': '用户组',
  'pages.addressBook.selectUser': '选择用户',
  'pages.addressBook.selectUserPlaceholder': '搜索用户名或邮箱',
  'pages.addressBook.everyoneHint': '所有用户将可以访问此地址簿',
  'pages.addressBook.allUsers': '所有用户',
  'pages.addressBook.addAccess': '添加权限',
  'pages.addressBook.accessLoadFailed': '加载共享权限失败',
  'pages.addressBook.accessAdded': '共享权限已添加',
  'pages.addressBook.accessAddFailed': '添加共享权限失败',
  'pages.addressBook.accessUpdated': '共享权限已更新',
  'pages.addressBook.accessUpdateFailed': '更新共享权限失败',
  'pages.addressBook.accessDeleted': '共享权限已删除',
  'pages.addressBook.accessDeleteFailed': '删除共享权限失败',
  'pages.addressBook.accessDeleteConfirm': '删除此共享权限？',
  'pages.roles.list': '角色列表',
  'pages.roles.name': '角色名称',
  'pages.roles.note': '备注',
  'pages.roles.permissions': '权限',
  'pages.roles.permissionsInfo': '实际权限和功能数量',
  'pages.roles.superAdminInfo':
    '超级管理员权限受到单独保护，无法通过角色授予。',
  'pages.roles.permissionsLoadFailed': '加载权限目录失败',
  'pages.roles.detailLoadFailed': '加载角色详情失败',
  'pages.roles.permissionScopeInfo':
    '为用户分配此角色时，设备操作可以全局授予，也可以限定到选定的设备组。',
  'pages.roles.personalAddressBook': '个人地址簿',
  'pages.roles.basicFunction': '基本功能',
  'pages.roles.permissionPresets': '权限预设',
  'pages.roles.preset.custom': '自定义',
  'pages.roles.preset.readOnly': '全局只读',
  'pages.roles.preset.deviceOperator': '设备运维',
  'pages.roles.preset.userAdministrator': '用户管理员',
  'pages.roles.preset.sharedAddressBookAdministrator': '共享地址簿管理员',
  'pages.roles.preset.strategyMaintainer': '策略维护员',
  'pages.roles.preset.deviceStrategyAssigner': '设备策略分配员',
  'pages.roles.preset.systemAdministrator': '系统管理员',
  'pages.roles.protectedAccount': '受保护账号',
  'pages.roles.protectedAccountInfo':
    '除超级管理员外，其他管理员不能管理受保护账号。',
  'pages.roles.ownerOnly': '仅超级管理员',
  'pages.roles.systemIdentity.ordinary': '普通用户',
  'pages.roles.systemIdentity.superAdmin': '超级管理员',
  'pages.roles.systemIdentity.builtIn': '系统内置',
  'pages.roles.systemIdentity.ordinarySummary': '仅提供个人地址簿基本功能。',
  'pages.roles.systemIdentity.superAdminSummary':
    '唯一系统所有者的完整有效权限。',
  'pages.roles.systemIdentity.systemCapabilities':
    '角色定义、系统设置、设备组结构和身份管理',
  'pages.roles.disableProtectionConfirm': '确定要取消此角色的账号保护吗？',
  'pages.roles.disableProtectionAffected':
    '{count} 个成员将可由受委派管理员管理。',
  'pages.roles.resource.servers': '服务器',
  'pages.roles.permission.servers.view': '查看服务器',
  'pages.roles.permission.servers.control': '控制服务器服务',
  'pages.roles.permission.servers.config': '配置服务器',
  'pages.roles.permission.servers.disconnect': '断开中继会话',
  'pages.roles.permission.servers.ban': '管理服务器封禁',
  'pages.roles.resource.users': '用户',
  'pages.roles.resource.user_groups': '用户组',
  'pages.roles.resource.devices': '设备',
  'pages.roles.resource.address_books': '地址簿',
  'pages.roles.resource.strategies': '策略',
  'pages.roles.resource.audit': '审计',
  'pages.roles.resource.roles': '角色',
  'pages.roles.resource.system': '系统能力',
  'pages.roles.resource.other': '其他',
  'pages.roles.unknownResource': '未知资源',
  'pages.roles.unknownPermission': '未知权限',
  'pages.roles.permission.users.view': '查看用户',
  'pages.roles.permission.users.create': '创建用户',
  'pages.roles.permission.users.edit': '编辑用户',
  'pages.roles.permission.users.status': '更改用户状态',
  'pages.roles.permission.users.delete': '删除用户',
  'pages.roles.permission.users.security': '管理用户安全设置',
  'pages.roles.permission.users.force_logout': '强制用户登出',
  'pages.roles.permission.user_groups.view': '查看用户组',
  'pages.roles.permission.user_groups.create': '创建用户组',
  'pages.roles.permission.user_groups.edit': '编辑用户组',
  'pages.roles.permission.user_groups.delete': '删除用户组',
  'pages.roles.permission.user_groups.membership': '管理用户组成员',
  'pages.roles.permission.devices.view': '查看设备',
  'pages.roles.permission.devices.edit': '编辑设备信息',
  'pages.roles.permission.devices.status': '更改设备状态',
  'pages.roles.permission.devices.delete': '删除设备',
  'pages.roles.permission.devices.disconnect': '断开设备连接',
  'pages.roles.permission.address_books.view': '查看共享地址簿设置',
  'pages.roles.permission.address_books.edit': '编辑共享地址簿',
  'pages.roles.permission.address_books.share': '创建和管理共享地址簿',
  'pages.roles.permission.strategies.view': '查看策略',
  'pages.roles.permission.strategies.create': '创建策略',
  'pages.roles.permission.strategies.edit': '编辑策略',
  'pages.roles.permission.strategies.delete': '删除策略',
  'pages.roles.permission.strategies.assign': '分配策略',
  'pages.roles.permission.audit.view': '查看审计日志',
  'pages.roles.permission.roles.view': '查看角色',
  'pages.roles.permission.roles.assign': '分配角色',
  'pages.roles.permission.roles.create': '创建角色',
  'pages.roles.permission.roles.edit': '编辑角色',
  'pages.roles.permission.roles.delete': '删除角色',
  'pages.roles.create': '创建角色',
  'pages.roles.view': '查看角色',
  'pages.roles.edit': '编辑角色',
  'pages.roles.deleteConfirm': '确定要删除此角色吗？',
  'pages.roles.selectPermissions': '选择权限',
  'pages.roles.createSuccess': '角色已创建',
  'pages.roles.createFailed': '创建角色失败',
  'pages.roles.updateSuccess': '角色已更新',
  'pages.roles.updateFailed': '更新角色失败',
  'pages.roles.deleteSuccess': '角色已删除',
  'pages.roles.deleteFailed': '删除角色失败',
  'pages.roles.searchNamePlaceholder': '搜索角色名称',
  'pages.roles.searchNotePlaceholder': '搜索备注',
  'pages.settings.save': '保存设置',
  'pages.settings.general': '常规设置',
  'pages.settings.fetchFailed': '加载设置失败',
  'pages.settings.saveSuccess': '设置保存成功',
  'pages.settings.saveFailed': '保存设置失败',
  'pages.settings.generalSection.watermark': '用户名水印',
  'pages.settings.generalSection.watermarkExtra':
    '在每个页面叠加显示当前用户名，便于追溯问责。',
  'pages.settings.generalSection.language': '默认语言',
  'pages.settings.generalSection.languageExtra':
    '新访客的默认界面语言。已登录用户保留其个人偏好。',
  'pages.settings.generalSection.languagePlaceholder': '请选择默认语言',
  'pages.settings.generalSection.site': '站点',
  'pages.settings.generalSection.frontendUrl': '前端地址',
  'pages.settings.generalSection.frontendUrlPlaceholder':
    'https://console.example.com',
  'pages.settings.generalSection.backendUrl': '后端地址',
  'pages.settings.generalSection.backendUrlExtra': '留空则使用与前端相同的源。',
  'pages.settings.generalSection.backendUrlPlaceholder':
    'https://api.example.com',
  'pages.settings.generalSection.urlInvalid': '请输入合法的 URL',
  'pages.settings.generalSection.webauthn': 'WebAuthn / 通行密钥',
  'pages.settings.generalSection.webauthnEnabled': '启用 WebAuthn',
  'pages.settings.generalSection.webauthnEnabledExtra':
    '允许用户注册并使用通行密钥登录。',
  'pages.settings.generalSection.webauthnUnsupported':
    '当前浏览器不支持 WebAuthn。在不支持的客户端上，通行密钥登录将不可用。',
  'pages.settings.generalSection.rpName': '依赖方名称',
  'pages.settings.generalSection.rpNameExtra': '通行密钥提示中展示的友好名称。',
  'pages.settings.generalSection.rpNamePlaceholder': 'RustDesk Console',
  'pages.settings.generalSection.security': '安全与维护',
  'pages.settings.generalSection.jwtExpiryDays': 'JWT Token 有效期（天）',
  'pages.settings.generalSection.jwtExpiryDaysExtra':
    '登录用户 Token 的有效天数，最小为 1。',
  'pages.settings.generalSection.jwtExpiryDaysRequired': '请输入正整数',
  'pages.settings.generalSection.auditRetentionDays': '审计日志保留（天）',
  'pages.settings.generalSection.auditRetentionDaysExtra':
    '审计日志保留天数，到期后自动清理。设为 0 表示不自动清理。',
  'pages.settings.generalSection.auditRetentionDaysRequired': '请输入非负整数',
  'pages.strategies.list': '策略列表',
  'pages.strategies.name': '策略名称',
  'pages.strategies.note': '备注',
  'pages.strategies.create': '创建策略',
  'pages.strategies.edit': '编辑策略',
  'pages.strategies.view': '查看策略',
  'pages.strategies.deleteConfirm': '确定要删除此策略吗？',
  'pages.strategies.createSuccess': '策略已创建',
  'pages.strategies.createFailed': '创建策略失败',
  'pages.strategies.updateSuccess': '策略已更新',
  'pages.strategies.updateFailed': '更新策略失败',
  'pages.strategies.deleteSuccess': '策略已删除',
  'pages.strategies.deleteFailed': '删除策略失败',
  'pages.strategies.enterName': '请输入策略名称',
  'pages.strategies.configOptions': '配置选项',
  'pages.strategies.defaultLabel': '默认',
  'pages.strategies.defaultValue': '默认值：{value}',
  'pages.strategies.resetToDefault': '重置为默认值',
  'pages.strategies.modifiedSummary': '已修改 {count} 项配置',
  'pages.strategies.resetAll': '全部重置',
  'pages.strategies.assign': '分配',
  'pages.strategies.assignManagement': '分配管理',
  'pages.strategies.loadAssignedFailed': '加载已分配目标失败',
  'pages.strategies.loadTargetsFailed': '加载目标失败',
  'pages.strategies.assignDevice': '设备',
  'pages.strategies.assignUser': '用户',
  'pages.strategies.assignDeviceGroup': '设备组',
  'pages.strategies.assignedTargets': '已分配目标',
  'pages.strategies.noAssigned': '暂无已分配目标',
  'pages.strategies.addAssignment': '新增分配',
  'pages.strategies.selectTarget': '请选择目标',
  'pages.strategies.assignSuccess': '策略分配成功',
  'pages.strategies.assignFailed': '策略分配失败',
  'pages.strategies.assignPartialFailed':
    '成功分配 {success} 个目标，{failed} 个失败：{errors}',
  'pages.strategies.unassignSuccess': '策略取消分配成功',
  'pages.strategies.unassignFailed': '策略取消分配失败',
  'pages.strategies.unassignConfirm': '确定要取消分配此目标吗？',
  'pages.strategies.fetchDetailFailed': '获取策略详情失败',
  'pages.strategies.updatedAt': '更新时间',
  'pages.strategies.category.connection': '连接与访问控制',
  'pages.strategies.category.security': '安全与认证',
  'pages.strategies.category.display': '显示与界面',
  'pages.strategies.category.av': '音视频与编解码',
  'pages.strategies.category.file': '文件与剪贴板',
  'pages.strategies.category.advanced': '高级设置',
  'pages.strategies.category.floating': '浮动窗口',
  'pages.strategies.category.privacy': '隐私与录制',
  'pages.strategies.values.yes': '是',
  'pages.strategies.values.no': '否',
  'pages.strategies.option.access-mode.label': '访问模式',
  'pages.strategies.option.enable-keyboard.label': '启用键盘和鼠标',
  'pages.strategies.option.enable-clipboard.label': '启用剪贴板',
  'pages.strategies.option.enable-file-transfer.label': '启用文件传输',
  'pages.strategies.option.enable-camera.label': '启用摄像头',
  'pages.strategies.option.enable-terminal.label': '启用终端',
  'pages.strategies.option.enable-remote-printer.label': '启用远程打印机',
  'pages.strategies.option.enable-tunnel.label': '启用隧道',
  'pages.strategies.option.enable-remote-restart.label': '启用远程重启',
  'pages.strategies.option.enable-block-input.label': '阻止输入',
  'pages.strategies.option.allow-auto-disconnect.label': '允许自动断开',
  'pages.strategies.option.auto-disconnect-timeout.label': '自动断开超时',
  'pages.strategies.option.allow-only-conn-window-open.label':
    '仅允许连接窗口打开',
  'pages.strategies.option.view-only.label': '仅查看',
  'pages.strategies.option.terminal-persistent.label': '终端持久化',
  'pages.strategies.option.allow-ask-for-note.label': '请求连接备注',
  'pages.strategies.option.allow-remote-config-modification.label':
    '允许远程修改配置',
  'pages.strategies.option.whitelist.label': 'IP 白名单',
  'pages.strategies.option.approve-mode.label': '审批模式',
  'pages.strategies.option.verification-method.label': '验证方式',
  'pages.strategies.option.temporary-password-length.label': '临时密码长度',
  'pages.strategies.option.lock-after-session-end.label': '会话结束后锁定',
  'pages.strategies.option.allow-remote-cm-modification.label':
    '允许远程客户端修改',
  'pages.strategies.option.enable-trusted-devices.label': '启用受信任设备',
  'pages.strategies.option.allow-numeric-one-time-password.label':
    '允许数字一次性密码',
  'pages.strategies.option.allow-insecure-tls-fallback.label':
    '允许不安全 TLS 回退',
  'pages.strategies.option.theme.label': '主题',
  'pages.strategies.option.lang.label': '语言',
  'pages.strategies.option.enable-confirm-closing-tabs.label': '确认关闭标签页',
  'pages.strategies.option.allow-remove-wallpaper.label': '允许移除壁纸',
  'pages.strategies.option.enable-open-new-connections-in-tabs.label':
    '在标签页中打开新连接',
  'pages.strategies.option.peer-card-ui-type.label': '设备卡片界面类型',
  'pages.strategies.option.peer-sorting.label': '设备排序方式',
  'pages.strategies.option.show-monitors-toolbar.label': '显示显示器工具栏',
  'pages.strategies.option.collapse-toolbar.label': '折叠工具栏',
  'pages.strategies.option.show-remote-cursor.label': '显示远程光标',
  'pages.strategies.option.follow-remote-cursor.label': '跟随远程光标',
  'pages.strategies.option.follow-remote-window.label': '跟随远程窗口',
  'pages.strategies.option.zoom-cursor.label': '放大光标',
  'pages.strategies.option.show-quality-monitor.label': '显示质量监视器',
  'pages.strategies.option.reverse-mouse-wheel.label': '反转鼠标滚轮',
  'pages.strategies.option.swap-left-right-mouse.label': '交换鼠标左右键',
  'pages.strategies.option.displays-as-individual-windows.label':
    '将显示器作为独立窗口显示',
  'pages.strategies.option.use-all-my-displays-for-the-remote-session.label':
    '远程会话使用所有显示器',
  'pages.strategies.option.view-style.label': '查看样式',
  'pages.strategies.option.scroll-style.label': '滚动样式',
  'pages.strategies.option.edge-scroll-edge-thickness.label': '边缘滚动厚度',
  'pages.strategies.option.trackpad-speed.label': '触控板速度',
  'pages.strategies.option.disable-group-panel.label': '禁用分组面板',
  'pages.strategies.option.keep-screen-on.label': '保持屏幕开启',
  'pages.strategies.option.disable-discovery-panel.label': '禁用发现面板',
  'pages.strategies.option.touch-mode.label': '触控模式',
  'pages.strategies.option.show-virtual-mouse.label': '显示虚拟鼠标',
  'pages.strategies.option.show-virtual-joystick.label': '显示虚拟摇杆',
  'pages.strategies.option.enable-audio.label': '启用音频',
  'pages.strategies.option.allow-always-software-render.label':
    '始终使用软件渲染',
  'pages.strategies.option.enable-hwcodec.label': '启用硬件编解码',
  'pages.strategies.option.use-texture-render.label': '使用纹理渲染',
  'pages.strategies.option.disable-audio.label': '禁用音频',
  'pages.strategies.option.i444.label': 'I444 颜色格式',
  'pages.strategies.option.image-quality.label': '图像质量',
  'pages.strategies.option.custom-image-quality.label': '自定义图像质量',
  'pages.strategies.option.custom-fps.label': '自定义帧率',
  'pages.strategies.option.enable-directx-capture.label': '启用 DirectX 捕获',
  'pages.strategies.option.enable-android-software-encoding-half-scale.label':
    '启用 Android 软件半尺寸编码',
  'pages.strategies.option.allow-d3d-render.label': '允许 D3D 渲染',
  'pages.strategies.option.enable-file-copy-paste.label': '启用文件复制和粘贴',
  'pages.strategies.option.disable-clipboard.label': '禁用剪贴板',
  'pages.strategies.option.sync-init-clipboard.label': '同步初始剪贴板',
  'pages.strategies.option.enable-lan-discovery.label': '启用局域网发现',
  'pages.strategies.option.direct-server.label': '直连服务器',
  'pages.strategies.option.allow-auto-update.label': '允许自动更新',
  'pages.strategies.option.enable-abr.label': '启用自适应码率',
  'pages.strategies.option.allow-linux-headless.label': '允许 Linux 无头模式',
  'pages.strategies.option.sync-ab-with-recent-sessions.label':
    '与最近会话同步地址簿',
  'pages.strategies.option.sync-ab-tags.label': '同步地址簿标签',
  'pages.strategies.option.filter-ab-by-intersection.label': '按交集筛选地址簿',
  'pages.strategies.option.enable-udp-punch.label': '启用 UDP 打洞',
  'pages.strategies.option.enable-ipv6-punch.label': '启用 IPv6 打洞',
  'pages.strategies.option.pre-elevate-service.label': '预提升服务权限',
  'pages.strategies.option.keep-awake-during-incoming-sessions.label':
    '传入会话期间保持唤醒',
  'pages.strategies.option.keep-awake-during-outgoing-sessions.label':
    '传出会话期间保持唤醒',
  'pages.strategies.option.disable-udp.label': '禁用 UDP',
  'pages.strategies.option.allow-websocket.label': '允许 WebSocket',
  'pages.strategies.option.disable-floating-window.label': '禁用浮动窗口',
  'pages.strategies.option.floating-window-size.label': '浮动窗口大小',
  'pages.strategies.option.floating-window-untouchable.label':
    '浮动窗口不可触摸',
  'pages.strategies.option.floating-window-transparency.label':
    '浮动窗口透明度',
  'pages.strategies.option.enable-record-session.label': '启用会话录制',
  'pages.strategies.option.allow-auto-record-incoming.label':
    '允许自动录制传入会话',
  'pages.strategies.option.allow-auto-record-outgoing.label':
    '允许自动录制传出会话',
  'pages.strategies.option.privacy-mode.label': '隐私模式',
  'pages.strategies.option.auto-disconnect-timeout.description':
    '超时时间（分钟）',
  'pages.strategies.option.lang.description': '语言代码',
  'pages.strategies.option.enable-ipv6-punch.description':
    '自托管：否，其他环境：是',
  'pages.strategies.option.use-texture-render.description': '取决于平台',
  'pages.strategies.option.whitelist.description': '以逗号分隔的 IP 列表',
  'pages.strategies.option.image-quality.value.best': '最佳',
  'pages.strategies.option.image-quality.value.balanced': '均衡',
  'pages.strategies.option.image-quality.value.low': '低',
  'pages.strategies.option.image-quality.value.custom': '自定义',
  'pages.strategies.option.access-mode.value.custom': '自定义',
  'pages.strategies.option.access-mode.value.full': '完全访问',
  'pages.strategies.option.access-mode.value.view': '仅查看',
  'pages.strategies.option.theme.value.dark': '深色',
  'pages.strategies.option.theme.value.light': '浅色',
  'pages.strategies.option.theme.value.system': '跟随系统',
  'pages.strategies.option.peer-card-ui-type.value.0': '卡片样式 0',
  'pages.strategies.option.peer-card-ui-type.value.1': '卡片样式 1',
  'pages.strategies.option.peer-card-ui-type.value.2': '卡片样式 2',
  'pages.strategies.option.peer-sorting.value.remote-id': '远程 ID',
  'pages.strategies.option.peer-sorting.value.remote-host': '远程主机',
  'pages.strategies.option.peer-sorting.value.username': '用户名',
  'pages.strategies.option.view-style.value.original': '原始',
  'pages.strategies.option.view-style.value.adaptive': '自适应',
  'pages.strategies.option.scroll-style.value.scrollauto': '自动',
  'pages.strategies.option.scroll-style.value.scrollbar': '滚动条',
  'pages.strategies.option.scroll-style.value.scrolledge': '边缘滚动',
  'pages.strategies.option.keep-screen-on.value.never': '从不',
  'pages.strategies.option.keep-screen-on.value.during-controlled':
    '受控会话期间',
  'pages.strategies.option.keep-screen-on.value.service-on': '服务运行时',
  'pages.strategies.option.approve-mode.value.password': '密码',
  'pages.strategies.option.approve-mode.value.click': '点击',
  'pages.strategies.option.approve-mode.value.password-click': '密码和点击',
  'pages.strategies.option.verification-method.value.use-temporary-password':
    '临时密码',
  'pages.strategies.option.verification-method.value.use-permanent-password':
    '永久密码',
  'pages.strategies.option.verification-method.value.use-both-passwords':
    '两种密码',
  'pages.strategies.option.temporary-password-length.value.6': '6 位',
  'pages.strategies.option.temporary-password-length.value.8': '8 位',
  'pages.strategies.option.temporary-password-length.value.10': '10 位',
  'pages.strategies.searchNamePlaceholder': '搜索策略名称',
  'pages.users.inviteSuccess': '邀请已发送',
  'pages.users.inviteFailed': '发送邀请失败',
  'pages.users.active': '活跃',
  'pages.users.disabled': '已禁用',
  'pages.users.unverified': '未验证',
  'pages.users.roles': '角色',
  'pages.users.rolesTitle': '{name} 的角色',
  'pages.users.rolesLoadFailed': '加载用户角色失败',
  'pages.users.rolesSaveFailed': '保存用户角色失败',
  'pages.users.rolesSaved': '用户角色已保存',
  'pages.users.addRole': '添加角色',
  'pages.users.superAdmin': '超级管理员',
  'pages.users.roleAssignmentTitle': '角色 {number}',
  'pages.users.selectRole': '选择角色',
  'pages.users.removeRole': '移除角色',
  'pages.users.roleRequired': '请为每项分配选择一个角色',
  'pages.users.duplicateRole': '同一角色只能分配一次',
  'pages.users.scopeMode': '角色范围模式',
  'pages.users.globalScope': '全局',
  'pages.users.deviceGroupScope': '指定设备组',
  'pages.users.selectDeviceGroups': '选择一个或多个设备组',
  'pages.users.unsupportedDeviceGroupScope':
    '仅包含设备操作和策略分配权限的角色可使用设备组范围',
  'pages.users.deviceGroupScopeRequired': '请至少选择一个设备组',
  'pages.users.rolesScopeInfo': '全局授权会覆盖范围更小的设备组授权。',
  'pages.users.protectedAccount': '受保护账号',
  'pages.users.protectedAccountInfo': '受保护账号只能由超级管理员管理。',
  'pages.users.systemOwnerStatusBlocked': '系统所有者不能被启用或禁用。',
  'pages.users.systemOwnerMutationBlocked': '系统所有者不能被禁用或删除。',
  'pages.users.systemCapabilities': '系统能力',
  'pages.users.systemCapability.roles.create': '创建角色定义',
  'pages.users.systemCapability.roles.edit': '编辑角色定义',
  'pages.users.systemCapability.roles.delete': '删除角色定义',
  'pages.users.systemCapability.settings.manage': '管理系统设置',
  'pages.users.systemCapability.device_groups.manage': '管理设备组结构',
  'pages.users.systemCapability.identity_sources.manage': '管理身份源',
  'pages.users.roleEligibility.assign_not_allowed': '当前管理员不能分配此角色',
  'pages.users.roleEligibility.remove_not_allowed': '当前管理员不能移除此角色',
  'pages.users.roleEligibility.protected_role':
    '受保护角色只能由超级管理员分配或移除',
  'pages.users.roleEligibility.protected_target': '目标账号受到保护',
  'pages.users.roleEligibility.super_admin_target':
    '超级管理员不能分配普通角色',
  'pages.users.roleEligibility.self_target': '不能修改自己的角色',
  'pages.users.roleEligibility.missing_caller_scope':
    '当前管理员没有所需权限范围',
  'pages.users.roleEligibility.scope_exceeds_caller':
    '角色范围超出当前管理员权限',
  'pages.users.roleEligibility.missing_permission':
    '当前管理员缺少角色所需权限',
  'pages.users.roleEligibility.role_grants_roles_assign':
    '包含角色分配权限的角色只能由超级管理员管理',
  'pages.users.effectiveScope': '实际生效范围',
  'pages.users.strategy': '策略',
  'pages.users.invite': '邀请用户',
  'pages.users.password': '密码',
  'pages.users.isAdmin': '管理员',
  'pages.users.normalUser': '普通用户',
  'pages.users.edit': '编辑用户',
  'pages.users.updateSuccess': '用户已更新',
  'pages.users.updateFailed': '更新用户失败',
  'pages.users.security': '安全',
  'pages.users.securitySettings': '安全设置',
  'pages.users.securityUpdateSuccess': '安全设置已更新',
  'pages.users.securityUpdateFailed': '更新安全设置失败',
  'pages.users.tfaEnforce': '强制双因素认证',
  'pages.users.emailVerification': '要求邮箱验证',
  'pages.users.resetPassword': '重置密码',
  'pages.users.resetPasswordTooltip': '留空则保持当前密码不变',
  'pages.users.confirmPassword': '确认密码',
  'pages.users.passwordMismatch': '两次输入的密码不一致',
  'pages.users.passwordTooShort': '密码长度不能少于6个字符',
  'pages.users.forceLogout': '登出',
  'pages.users.forceLogoutSuccess': '强制登出成功',
  'pages.users.forceLogoutFailed': '强制登出失败',
  'pages.users.batchEnable': '批量启用',
  'pages.users.batchDisable': '批量禁用',
  'pages.users.batchForceLogout': '批量强制登出',
  'pages.users.batchEnableConfirm': '确定要启用选中的用户吗？',
  'pages.users.batchDisableConfirm': '确定要禁用选中的用户吗？',
  'pages.users.batchForceLogoutConfirm': '确定要强制登出选中的用户吗？',
  'pages.users.batchEnableSuccess': '成功启用 {count} 个用户',
  'pages.users.batchEnableFailed': '启用用户失败',
  'pages.users.batchEnablePartialFailed':
    '成功启用 {success} 个用户，{failed} 个失败',
  'pages.users.batchDisableSuccess': '成功禁用 {count} 个用户',
  'pages.users.batchDisableFailed': '禁用用户失败',
  'pages.users.batchDisablePartialFailed':
    '成功禁用 {success} 个用户，{failed} 个失败',
  'pages.users.batchForceLogoutSuccess': '批量强制登出成功',
  'pages.users.batchForceLogoutFailed': '批量强制登出失败',
  'pages.dashboard.totalUsers': '用户总数',
  'pages.dashboard.adminUsers': '管理员',
  'pages.dashboard.normalUsers': '普通',
  'pages.dashboard.totalDevices': '设备总数',
  'pages.dashboard.onlineDevices': '在线',
  'pages.dashboard.offlineDevices': '离线',
  'pages.dashboard.todayConnections': '今日连接',
  'pages.dashboard.successCount': '成功',
  'pages.dashboard.failureCount': '失败',
  'pages.dashboard.todayTransfers': '今日传输',
  'pages.dashboard.uploadCount': '上传',
  'pages.dashboard.downloadCount': '下载',
  'pages.dashboard.systemStatus': '系统状态',
  'pages.dashboard.uptime': '运行时间',
  'pages.dashboard.trendData': '趋势数据',
  'pages.dashboard.alarmTrend': '告警',
  'pages.dashboard.resourceCounts': '资源统计',
  'pages.dashboard.addressBooks': '地址簿',
  'pages.dashboard.groups': '组',
  'pages.dashboard.roles': '角色',
  'pages.dashboard.strategies': '策略',
  'pages.common.pleaseEnterName': '请输入名称',
  'pages.common.pleaseEnterId': '请输入 ID',
  'pages.common.pleaseEnterTagName': '请输入标签名称',
  'pages.common.pleaseEnterUsername': '请输入用户名',
  'pages.common.pleaseEnterEmail': '请输入邮箱',
  'pages.common.pleaseEnterValidEmail': '请输入有效的邮箱地址',
  'pages.common.pleaseEnterPassword': '请输入密码',
  'pages.common.pleaseEnterRoleName': '请输入角色名称',
  'pages.common.id': 'ID',
  'pages.dashboard.day': '天',
  'pages.dashboard.hour': '小时',
  'pages.dashboard.min': '分钟',
  'pages.dashboard.cpu': 'CPU',
  'pages.dashboard.memory': '内存',
  'pages.dashboard.disk': '磁盘',
  'pages.dashboard.connectionTrend': '连接数',
  'pages.dashboard.newUsersTrend': '新增用户',

  'pages.dashboard.7days': '7 天',
  'pages.dashboard.30days': '30 天',
  'pages.dashboard.90days': '90 天',
  'pages.dashboard.noData': '暂无数据',
  'pages.smtp.title': 'SMTP 配置',
  'pages.smtp.description': '配置 SMTP 邮件服务器用于发送系统通知邮件',
  'pages.smtp.host': '服务器地址',
  'pages.smtp.hostPlaceholder': '请输入 SMTP 服务器地址',
  'pages.smtp.port': '端口',
  'pages.smtp.portPlaceholder': '请输入端口号',
  'pages.smtp.secure': '使用 SSL/TLS',
  'pages.smtp.secureHelp':
    '启用安全连接（通常端口 465 使用 SSL，端口 587 使用 TLS）',
  'pages.smtp.user': '用户名',
  'pages.smtp.userPlaceholder': '请输入 SMTP 认证用户名',
  'pages.smtp.password': '密码',
  'pages.smtp.passwordPlaceholder': '请输入 SMTP 认证密码',
  'pages.smtp.from': '发件人邮箱',
  'pages.smtp.fromPlaceholder': '请输入发件人邮箱地址',
  'pages.smtp.enabled': '启用配置',
  'pages.smtp.enabledHelp': '启用后将使用此配置发送系统邮件',
  'pages.smtp.testConnection': '测试连接',
  'pages.smtp.testSuccess': 'SMTP 连接测试成功',
  'pages.smtp.testFailed': 'SMTP 连接测试失败',
  'pages.smtp.saveSuccess': 'SMTP 配置保存成功',
  'pages.smtp.saveFailed': 'SMTP 配置保存失败',
  'pages.smtp.createdAt': '创建时间',
  'pages.smtp.updatedAt': '更新时间',
  'pages.addressBook.color': '颜色',
  'pages.addressBook.deviceInfo': '用户名@设备名',
  'pages.addressBook.manageTags': '管理标签',
  'pages.addressBook.newTagName': '新标签名称',
  'pages.addressBook.peerUpdateFailed': '更新对等端失败',
  'pages.addressBook.peerUpdated': '对等端已更新',
  'pages.addressBook.renameTag': '重命名标签',
  'pages.addressBook.selectTags': '选择标签',
  'pages.addressBook.tagColorUpdateFailed': '更新标签颜色失败',
  'pages.addressBook.tagRenameFailed': '重命名标签失败',
  'pages.addressBook.tagRenamed': '标签已重命名',
  'pages.addressBook.untagged': '未标记',
  'pages.addressBook.searchIdPlaceholder': '搜索ID',
  'pages.addressBook.searchNamePlaceholder': '搜索名称',
  'pages.addressBook.searchNotePlaceholder': '搜索备注',
  'pages.common.cancel': '否',
  'pages.common.confirm': '是',
  'pages.common.enterDescription': '请输入描述',
  'pages.common.rename': '重命名',
  'pages.common.save': '保存',
  'pages.common.close': '关闭',
  'pages.common.back': '返回',
  'pages.userGroups.enterName': '请输入组名称',
  'pages.userGroups.searchNamePlaceholder': '搜索名称',
  'pages.users.admin': '管理员',
  'pages.users.me': '我',
  'pages.users.searchNamePlaceholder': '搜索用户名',
  'pages.users.searchEmailPlaceholder': '搜索邮箱',
  'pages.users.searchStrategyPlaceholder': '搜索策略',
  'pages.users.searchUserGroupPlaceholder': '搜索用户组',
  'pages.oidcProviders.list': 'OIDC 提供商列表',
  'pages.oidcProviders.sort': '排序',
  'pages.oidcProviders.name': '提供商名称',
  'pages.oidcProviders.type': '类型',
  'pages.oidcProviders.issuer': '发行者 URL',
  'pages.oidcProviders.clientId': '客户端 ID',
  'pages.oidcProviders.clientSecret': '客户端密钥',
  'pages.oidcProviders.scope': '授权范围',
  'pages.oidcProviders.authorizationEndpoint': '授权端点',
  'pages.oidcProviders.tokenEndpoint': '令牌端点',
  'pages.oidcProviders.userinfoEndpoint': '用户信息端点',
  'pages.oidcProviders.jwksUri': 'JWKS 端点',
  'pages.oidcProviders.enabled': '启用状态',
  'pages.oidcProviders.endpointConfig': '端点配置',
  'pages.oidcProviders.create': '创建提供商',
  'pages.oidcProviders.edit': '编辑提供商',
  'pages.oidcProviders.test': '测试',
  'pages.oidcProviders.testResult': '测试连接结果',
  'pages.oidcProviders.discoveredEndpoints': '自动发现的端点',
  'pages.oidcProviders.enterName': '请输入提供商名称',
  'pages.oidcProviders.enterIssuer': '请输入发行者 URL',
  'pages.oidcProviders.enterClientId': '请输入客户端 ID',
  'pages.oidcProviders.enterClientSecret': '请输入客户端密钥',
  'pages.oidcProviders.enterEndpoint': '留空则自动发现',
  'pages.oidcProviders.createSuccess': 'OIDC 提供商已创建',
  'pages.oidcProviders.createFailed': '创建 OIDC 提供商失败',
  'pages.oidcProviders.updateSuccess': 'OIDC 提供商已更新',
  'pages.oidcProviders.updateFailed': '更新 OIDC 提供商失败',
  'pages.oidcProviders.deleteSuccess': 'OIDC 提供商已删除',
  'pages.oidcProviders.deleteFailed': '删除 OIDC 提供商失败',
  'pages.oidcProviders.deleteConfirm': '确定要删除此提供商吗？',
  'pages.oidcProviders.enableSuccess': 'OIDC 提供商已启用',
  'pages.oidcProviders.enableFailed': '启用 OIDC 提供商失败',
  'pages.oidcProviders.disableSuccess': 'OIDC 提供商已禁用',
  'pages.oidcProviders.disableFailed': '禁用 OIDC 提供商失败',
  'pages.oidcProviders.enableConfirm': '确定要启用此提供商吗？',
  'pages.oidcProviders.disableConfirm': '确定要禁用此提供商吗？',
  'pages.oidcProviders.testFailed': '测试 OIDC 连接失败',
  'pages.oidcProviders.fetchDetailFailed': '获取提供商详情失败',
  'pages.oidcProviders.sortFailed': '更新提供商排序失败',
  'pages.oidcProviders.preset': '提供商模板',
  'pages.oidcProviders.presetPlaceholder': '选择内置提供商或自定义',
  'pages.oidcProviders.custom': '自定义',
  'pages.oidcProviders.icon': '图标 (SVG)',
  'pages.oidcProviders.uploadSvg': '上传 SVG',
  'pages.oidcProviders.clearIcon': '清除',
  'pages.oidcProviders.svgTooLarge': 'SVG 文件过大（最大 100KB）',
  'pages.oidcProviders.invalidSvg': '无效的 SVG 内容',
  'pages.user.center.tab.basic': '基本信息',
  'pages.user.center.tab.security': '安全设置',
  'pages.user.center.basicInfo.displayName': '显示名称',
  'pages.user.center.basicInfo.displayNamePlaceholder': '请输入显示名称',
  'pages.user.center.basicInfo.name': '用户名',
  'pages.user.center.basicInfo.email': '邮箱',
  'pages.user.center.basicInfo.note': '备注',
  'pages.user.center.basicInfo.updateSuccess': '用户信息已更新',
  'pages.user.center.basicInfo.updateFailed': '更新用户信息失败',
  'pages.user.center.avatar.hint':
    '支持 JPG、PNG、WebP 格式，最大 2MB，将自动缩放为 256x256',
  'pages.user.center.avatar.upload': '上传头像',
  'pages.user.center.avatar.delete': '删除头像',
  'pages.user.center.avatar.deleteConfirm': '确定要删除头像吗？',
  'pages.user.center.avatar.uploadSuccess': '头像上传成功',
  'pages.user.center.avatar.uploadFailed': '头像上传失败',
  'pages.user.center.avatar.deleteSuccess': '头像已删除',
  'pages.user.center.avatar.deleteFailed': '删除头像失败',
  'pages.user.center.avatar.fileTooLarge': '文件大小不能超过 2MB',
  'pages.user.center.avatar.invalidFormat': '仅支持 JPG、PNG、WebP 格式',
  'pages.user.center.security.title': '安全设置',
  'pages.user.center.security.2faStatus': '双因素认证状态',
  'pages.user.center.security.enabled': '已启用',
  'pages.user.center.security.disabled': '未启用',
  'pages.user.center.security.enable2FA': '启用 2FA',
  'pages.user.center.security.disable2FA': '禁用 2FA',
  'pages.user.center.security.setup2FA': '设置双因素认证',
  'pages.user.center.security.setupFailed': '设置 2FA 失败',
  'pages.user.center.security.scanQRCode':
    '请使用认证器应用扫描二维码，然后输入验证码完成绑定。',
  'pages.user.center.security.secretKey': '密钥',
  'pages.user.center.security.verificationCode': '验证码',
  'pages.user.center.security.enterCode': '请输入验证码',
  'pages.user.center.security.verifyAndEnable': '验证并启用',
  'pages.user.center.security.enableSuccess': '2FA 已启用',
  'pages.user.center.security.enableFailed': '启用 2FA 失败',
  'pages.user.center.security.currentCode': '当前验证码',
  'pages.user.center.security.confirmDisable': '确认禁用',
  'pages.user.center.security.disableSuccess': '2FA 已禁用',
  'pages.user.center.security.disableFailed': '禁用 2FA 失败',
  'pages.user.center.security.password': '登录密码',
  'pages.user.center.security.passwordSet': '已设置',
  'pages.user.center.security.passwordNotSet': '未设置',
  'pages.user.center.security.changePassword': '修改密码',
  'pages.user.center.security.currentPassword': '当前密码',
  'pages.user.center.security.enterCurrentPassword': '请输入当前密码',
  'pages.user.center.security.newPassword': '新密码',
  'pages.user.center.security.enterNewPassword': '请输入新密码（至少6位）',
  'pages.user.center.security.confirmNewPassword': '确认新密码',
  'pages.user.center.security.confirmNewPasswordPlaceholder':
    '请再次输入新密码',
  'pages.user.center.security.passwordMinLength': '密码长度不能少于6位',
  'pages.user.center.security.passwordMismatch': '两次输入的密码不一致',
  'pages.user.center.security.changePasswordSuccess': '密码修改成功',
  'pages.user.center.security.changePasswordFailed': '密码修改失败',
  'pages.user.center.security.thirdPartyUser': '第三方登录用户不支持修改密码',
  'pages.user.center.security.noPasswordUser': '当前账户未设置密码，无法修改',
  'pages.user.center.security.passkey.title': 'Passkey 管理',
  'pages.user.center.security.passkey.register': '注册 Passkey',
  'pages.user.center.security.passkey.registerSuccess': 'Passkey 注册成功',
  'pages.user.center.security.passkey.registerFailed': '注册 Passkey 失败',
  'pages.user.center.security.passkey.deleteSuccess': 'Passkey 已删除',
  'pages.user.center.security.passkey.deleteFailed': '删除 Passkey 失败',
  'pages.user.center.security.passkey.deleteConfirm':
    '确定要删除此 Passkey 吗？',
  'pages.user.center.security.passkey.name': '名称',
  'pages.user.center.security.passkey.namePlaceholder':
    '例如：MacBook Touch ID',
  'pages.user.center.security.passkey.namePasskey': '为您的 Passkey 命名',
  'pages.user.center.security.passkey.deviceType': '设备类型',
  'pages.user.center.security.passkey.multiDevice': '多设备',
  'pages.user.center.security.passkey.singleDevice': '单设备',
  'pages.user.center.security.passkey.createdAt': '创建时间',
  'pages.user.center.security.passkey.noCredentials': '暂无已注册的 Passkey',
  'pages.user.center.security.passkey.tfaStatus': 'Passkey 双因素认证',
  'pages.user.center.security.passkey.tfaEnabled': '已启用 Passkey 双因素认证',
  'pages.user.center.security.passkey.tfaDisabled': '已禁用 Passkey 双因素认证',
  'pages.user.center.security.passkey.tfaToggleFailed':
    '切换 Passkey 双因素认证失败',
  'pages.user.center.security.sessions.title': '登录会话',
  'pages.user.center.security.sessions.device': '设备',
  'pages.user.center.security.sessions.type': '类型',
  'pages.user.center.security.sessions.browser': '浏览器',
  'pages.user.center.security.sessions.client': '客户端',
  'pages.user.center.security.sessions.os': '操作系统',
  'pages.user.center.security.sessions.createdAt': '创建时间',
  'pages.user.center.security.sessions.expiresAt': '过期时间',
  'pages.user.center.security.sessions.current': '当前',
  'pages.user.center.security.sessions.revoke': '撤销',
  'pages.user.center.security.sessions.revokeConfirm': '确定要撤销此会话吗？',
  'pages.user.center.security.sessions.revokeSuccess': '会话已撤销',
  'pages.user.center.security.sessions.revokeFailed': '撤销会话失败',
  'pages.user.center.security.sessions.cannotRevokeCurrent': '无法撤销当前会话',
  'pages.user.center.security.sessions.noSessions': '暂无活动会话',
  'pages.ldap.title': 'LDAP 配置',
  'pages.ldap.description':
    '配置 LDAP/Active Directory 认证。启用后，用户将通过 LDAP 服务器进行身份验证。',
  'pages.ldap.urls': '服务器地址',
  'pages.ldap.urlsRequired': '请输入至少一个 LDAP 服务器地址',
  'pages.ldap.urlPlaceholder': '例如 ldaps://ad.example.com:636',
  'pages.ldap.addUrl': '添加服务器地址',
  'pages.ldap.bindDN': '绑定 DN',
  'pages.ldap.bindDNRequired': '请输入服务账号绑定 DN',
  'pages.ldap.bindDNPlaceholder':
    '例如 CN=svc-ldap,OU=ServiceAccounts,DC=example,DC=com',
  'pages.ldap.bindCredentials': '绑定密码',
  'pages.ldap.bindCredentialsRequired': '请输入服务账号密码',
  'pages.ldap.bindCredentialsPlaceholder': '请输入服务账号密码',
  'pages.ldap.searchBase': '搜索基础 DN',
  'pages.ldap.searchBaseRequired': '请输入搜索基础 DN',
  'pages.ldap.searchBasePlaceholder': '例如 DC=example,DC=com',
  'pages.ldap.searchFilter': '搜索过滤器',
  'pages.ldap.searchFilterRequired': '请输入搜索过滤器',
  'pages.ldap.searchFilterHelp':
    '使用 {{username}} 作为用户名占位符。AD: (sAMAccountName={{username}})，OpenLDAP: (uid={{username}})',
  'pages.ldap.searchFilterPlaceholder': '例如 (sAMAccountName={{username}})',
  'pages.ldap.searchAttributes': '搜索属性',
  'pages.ldap.searchAttributePlaceholder':
    '例如 dn, sAMAccountName, mail, displayName',
  'pages.ldap.addAttribute': '添加属性',
  'pages.ldap.groupSearchBase': '组搜索基础 DN',
  'pages.ldap.groupSearchBasePlaceholder': '例如 OU=Groups,DC=example,DC=com',
  'pages.ldap.groupSearchFilter': '组搜索过滤器',
  'pages.ldap.groupSearchFilterHelp':
    '使用 {{dn}} 作为用户 DN 占位符。例如 (member={{dn}})',
  'pages.ldap.groupSearchFilterPlaceholder': '例如 (member={{dn}})',
  'pages.ldap.adminGroups': '管理员组',
  'pages.ldap.adminGroupsHelp':
    '属于这些 LDAP 组的用户将被映射为管理员（大小写不敏感匹配）',
  'pages.ldap.adminGroupPlaceholder':
    '例如 CN=Admins,OU=Groups,DC=example,DC=com',
  'pages.ldap.addAdminGroup': '添加管理员组',
  'pages.ldap.tlsOptions': 'TLS 选项',
  'pages.ldap.tlsCa': 'CA 证书（PEM 格式）',
  'pages.ldap.tlsCaPlaceholder': '-----BEGIN CERTIFICATE-----\n...',
  'pages.ldap.tlsCert': '客户端证书（PEM 格式）',
  'pages.ldap.tlsCertPlaceholder': '-----BEGIN CERTIFICATE-----\n...',
  'pages.ldap.tlsKey': '客户端私钥（PEM 格式）',
  'pages.ldap.tlsKeyPlaceholder': '-----BEGIN PRIVATE KEY-----\n...',
  'pages.ldap.tlsServername': 'SNI 服务器名称',
  'pages.ldap.tlsServernamePlaceholder': 'TLS 服务器名称指示',
  'pages.ldap.enabled': '启用 LDAP 认证',
  'pages.ldap.enabledHelp':
    '启用后，用户将通过 LDAP 服务器进行身份验证。已关联 LDAP 的用户无论此设置如何，始终使用 LDAP 认证。',
  'pages.ldap.testConnection': '测试连接',
  'pages.ldap.testSuccess': 'LDAP 连接测试成功',
  'pages.ldap.testFailed': 'LDAP 连接测试失败',
  'pages.ldap.saveSuccess': 'LDAP 配置保存成功',
  'pages.ldap.saveFailed': 'LDAP 配置保存失败',
  'pages.ldap.createdAt': '创建时间',
  'pages.ldap.updatedAt': '更新时间',
  'pages.nexus.repoRequired': '需要仓库互动',
  'pages.nexus.repoRequiredDesc':
    '您需要对 databk/rustdesk-console GitHub 仓库进行 Star、Fork 或 Watch 操作后才能生成自定义客户端。操作后最长需等待 5 分钟缓存刷新。',
  'pages.nexus.goToRepo': '前往 GitHub 仓库',
  'pages.nexus.buildList': '构建历史',
  'pages.nexus.createBuild': '创建新客户端',
  'pages.nexus.createBuildTitle': '创建自定义客户端',
  'pages.nexus.customConfig': '定制配置',
  'pages.nexus.serverConfig': '服务器配置',
  'pages.nexus.password': '密码',
  'pages.nexus.passwordPlaceholder': '请输入密码',
  'pages.nexus.salt': '盐值',
  'pages.nexus.saltPlaceholder': '请输入盐值',
  'pages.nexus.connType': '连接类型',
  'pages.nexus.disableInstallation': '禁用安装功能',
  'pages.nexus.disableSettings': '禁用设置功能',
  'pages.nexus.disableAccount': '禁用账户功能',
  'pages.nexus.disableAb': '禁用AB功能',
  'pages.nexus.disableTcpListen': '禁用TCP监听',
  'pages.nexus.rendezvousServer': 'ID 服务器',
  'pages.nexus.relayServer': '中继服务器',
  'pages.nexus.key': '密钥',
  'pages.nexus.apiServer': 'API 服务器',
  'pages.nexus.overrideSettings': '覆盖设置',
  'pages.nexus.defaultSettings': '默认设置',
  'pages.nexus.deleteBuildConfirm': '确定要删除此构建记录吗？',
  'pages.nexus.deleteSuccess': '构建记录已删除',
  'pages.nexus.deleteFailed': '删除构建记录失败',
  'pages.nexus.uuid': 'UUID',
  'pages.nexus.os': '操作系统',
  'pages.nexus.arch': '架构',
  'pages.nexus.appName': '应用名称',
  'pages.nexus.appNamePlaceholder': '例如 my-rustdesk',
  'pages.nexus.appNameHint': '仅允许英文字母',
  'pages.nexus.bindSuccess': 'Github 账号绑定成功',
  'pages.nexus.bindFailed': 'Github 账号绑定失败',
  'pages.nexus.createLoginFailed': '创建登录会话失败',
  'pages.nexus.unbindConfirm': '解绑 Github 账号',
  'pages.nexus.unbindConfirmContent':
    '确定要解绑 Github 账号吗？解绑后需要重新绑定才能生成自定义客户端。',
  'pages.nexus.unbindSuccess': 'Github 账号已解绑',
  'pages.nexus.unbindFailed': '解绑 Github 账号失败',
  'pages.nexus.tokenExpired': 'Github Token 已过期',
  'pages.nexus.tokenExpiredDesc':
    'Github 账号 {username} 的 Token 已过期，请重新绑定。',
  'pages.nexus.rebind': '重新绑定 Github 账号',
  'pages.nexus.bindTitle': '绑定 Github 账号',
  'pages.nexus.bindDesc':
    '您需要绑定 GitHub 账号才能生成自定义客户端。点击下方按钮通过 GitHub 授权。',
  'pages.nexus.bindGithub': '通过 GitHub 授权',
  'pages.nexus.unbind': '解绑',
  'pages.nexus.repoInteractionRequired':
    '请先对 databk/rustdesk-console 仓库进行 Star、Fork 或 Watch 操作。操作后最长需等待 5 分钟缓存刷新。',
  'pages.nexus.buildAlreadyRunning': '已有一个正在进行的构建任务',
  'pages.nexus.generateFailed': '提交构建请求失败',
  'pages.nexus.retryBuild': '重试',
  'pages.nexus.retryBuildFailed': '重试构建失败',
  'pages.nexus.downloadFailed': '下载自定义客户端失败',
  'pages.nexus.buildAgain': '再次构建',
  'pages.nexus.status': '状态',
  'pages.nexus.statusPending': '等待构建',
  'pages.nexus.statusBuilding': '构建中',
  'pages.nexus.statusCompleted': '构建完成',
  'pages.nexus.statusFailed': '构建失败',
  'pages.nexus.statusCancelled': '构建已取消',
  'pages.nexus.bindWhyLogin':
    '通过 GitHub 身份验证，我们可以确认您是真实用户，从而防止构建资源被自动化滥用。我们仅获取您的公开信息——不会请求访问您的仓库、个人数据或任何其他权限。',
  'pages.nexus.repoWhyInteract':
    '我是一名高中生，利用课余时间开发这个项目。您的 Star、Fork 或 Watch 对我意义重大——这不仅是对我持续开发的鼓励，也有助于我的大学申请。这是我所请求的唯一回报。非常感谢您的支持！',
};
